import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { Project } from '../models/project.model';
import { ActivatedRoute, Router } from '@angular/router';
import { skip } from 'rxjs';
import { ProjectModalsComponent } from '../shared/project-modals/project-modals.component';
import { FileTransferService } from '../services/file-transfer.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-admin-project-overview',
  templateUrl: './admin-project-overview.component.html',
  styleUrls: ['./admin-project-overview.component.css'],
  standalone: false
})
export class AdminProjectOverviewComponent {
  @ViewChild('projectModals') private projectModals!: ProjectModalsComponent;
  projects: Project[] = [];
  private readonly destroyRef = inject(DestroyRef);
  areProjectsLoading = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly projectService: ProjectService,
    private readonly fileTransferService: FileTransferService
  ) {}

  ngOnInit(): void {
    this.areProjectsLoading = true;
    this.projectService.projects$.pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe(projects => {
      this.projects = projects;
      this.areProjectsLoading = false;
    });
    this.projectService.getProjects();
  }

  startCalculation(id: number) {
    this.router.navigate(['./projects', id], { relativeTo: this.activatedRoute });
  }

  async editProject(selectedProject: Project) {
    this.projectModals.editProject(selectedProject);
  }

  async openDeleteModal(project: Project) {
    this.projectModals.openDeleteModal(project);
  }

  downloadProjectFile(project: Project) {
    this.fileTransferService.downloadFile('Project', project);
  }
}
